export default "__VITE_ASSET__zt$aH_PJ__"